/* import __COLOCATED_TEMPLATE__ from './form-feedback-bubble-content.hbs'; */
import Component from '@ember/component';
import EmberObject, { computed, observer } from '@ember/object';
import { inject as service } from '@ember/service';
import { TYPES } from 'sh-www/constants/form-feedback-bubble';

const CLASS_NAME = 'SH-c-form-feedback-bubble-content';

const typeData = (color, icon) => ({ color, icon });

const TYPE_DATA = {
  [TYPES.ERROR]: typeData('lsg-medium-red', 'warning'),
  [TYPES.WARNING]: typeData('lsg-yellow', 'info'),
  [TYPES.SUCCESS]: typeData('lsg-green', 'check_circle_outline'),
  [TYPES.NONE]: typeData(null, null),
};

/**
 * An absolutely-positioned bubble that displays feedback beside a form. Requires its parent to be
 * relatively-positioned in order to be displayed correctly.
 */
export default Component.extend({
  tagName: '',
  CLASS_NAME,
  TYPES,

  /** @param {String} type The type of feedback. */
  type: TYPES.NONE,

  /** @type {Ember.Object} The data associated with the current type. */
  _typeData: computed('type', function () {
    return EmberObject.create(TYPE_DATA[this.get('type')]);
  }),

  /** @type {Boolean} Whether the feedback bubble is in the expanded state. */
  _isExpanded: true,

  media: service(),

  /** Expands the bubble whenever the device surpasses the large breakpoint. */
  mediaObserver: observer('media.isLargeAndUp', function () {
    if (this.get('media.isLargeAndUp')) {
      this.set('_isExpanded', true);
    }
  }),

  actions: {
    collapse() {
      this.set('_isExpanded', false);
    },

    expand() {
      this.set('_isExpanded', true);
    },
  },
});
